/**
 * Компактная подпись длительности для пресетов: круглые минуты — "1m", "5m";
 * всё остальное (в том числе некратное минуте, например 90) — в секундах: "90s".
 */
export const formatDurationLabel = (totalSeconds: number): string => {
  const isWholeMinutes = totalSeconds > 0 && totalSeconds % 60 === 0;
  return isWholeMinutes ? `${totalSeconds / 60}m` : `${totalSeconds}s`;
};
